import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './TrafficLight.less';

const cx = classnames.bind(styles);

TrafficLight.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      color: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

function renderSupportingFactors(data) {
  const supportingFactors = [];
  const size = data.length;
  let counter = 1;
  while (size > counter) {
    if (counter + 1 !== size) {
      supportingFactors.push(
        <div className={cx('row')} key={counter}>
          <div className={cx('column-factor')}>
            <svg>
              <rect rx="5px" fill={data[counter].color} />
              <text x="12.5px" y="17.5px">
                {data[counter].value}
              </text>
            </svg>
          </div>
          <div className={cx('column-label')}>
            <div className={cx('label')}>{data[counter].label}</div>
          </div>
          <div className={cx('column-factor')}>
            <svg>
              <rect rx="5px" fill={data[counter + 1].color} />
              <text x="12.5px" y="17.5px">
                {data[counter + 1].value}
              </text>
            </svg>
          </div>
          <div className={cx('column-label')}>
            <div className={cx('label')}>{data[counter + 1].label}</div>
          </div>
        </div>
      );
      counter = counter + 2;
    } else {
      supportingFactors.push(
        <div className={cx('row')} key={counter}>
          <div className={cx('column-factor')}>
            <svg>
              <rect rx="5px" fill={data[counter].color} />
              <text x="13px" y="17.5px">
                {data[counter].value}
              </text>
            </svg>
          </div>
          <div className={cx('column-label')}>
            <div className={cx('label')}>{data[counter].label}</div>
          </div>
        </div>
      );
      counter = counter + 1;
    }
  }
  return supportingFactors;
}

export default function TrafficLight({ data }) {
  const mainFactor = data[0];
  const supportingFactors = renderSupportingFactors(data);
  return (
    <div>
      <div className={cx('main-factor')}>
        <svg>
          <circle cx="50%" cy="50%" r="90px" fill={mainFactor.color} />
          <text x="50%" y="60%">
            {mainFactor.value}
          </text>
        </svg>
      </div>

      <div className={cx('supporting-factors')}>{supportingFactors}</div>
    </div>
  );
}
